<template>
  <div class="whitespace-nowrap">
    <button
      class="reviews-button"
      :data-review-count="count"
      @click.prevent="handleReviewsClick"
    >
      <DynamicStars v-bind="{ count, rating }" />
    </button>
    <VueModal
      v-model="reviewsModalActive"
      @close="reviewsModalActive = false"
    >
      <ProductReviewsModal
        v-bind="{ productId, productTitle }"
        @close="reviewsModalActive = false"
      />
    </VueModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import DynamicStars from '@/components/shared/dynamic-stars.vue'
import VueModal from '@/components/theme/render/vue-modal.vue'
import ProductReviewsModal from '@/components/products/product-reviews-modal.vue'

export interface Props {
  productId: number
  productTitle: string
  count: number
  rating: number
}

defineProps<Props>()

const reviewsModalActive = ref(false)

const handleReviewsClick = (e: Event) => {
  const parent = (e.target as HTMLElement).closest('button.reviews-button') as HTMLButtonElement
  if (parent && Number(parent.dataset.reviewCount) > 0) {
    reviewsModalActive.value = true
  }
}
</script>
